import Error from '../model/Error';
import MemberApplicationConfiguration from '../dto/MemberApplicationConfiguration';
import axios from 'axios';

export default class MemberApplicationConfigurationRepository {
    static findByClubId(clubId) {
        return new Promise((resolve, reject) => {
            axios
                .get(`/club/clubs/${clubId}/member-application/configuration`)
                .then((response) => resolve(MemberApplicationConfiguration.fromData(response.data.data)))
                .catch((error) => reject(Error.fromResponse(error.response)));
        });
    }
}
